import createApyRatesAtom from './apy-rates.js'

export const apyRatesAtomDefinition = {
  id: 'apyRatesAtom',
  type: 'atom',
  factory: createApyRatesAtom,
  dependencies: [],
  public: true,
}
